export const Theme = {
  primary: '#49b39d',
  primaryDark: '#2c6b5e',
  primaryLight: '#92d1c4',
  secondary: '#FF8C5C',
  secondaryDark: '#F8733B',
  black: '#222222',
  success: '#62DC4F',
  warning: '#F74949',
  alert: '#F9BD35',
  lines: '#f5f5f5',
  gray: '#E8EBEF',
  grayLight: '#F6F9FC',
  white: '#FFFFFF',
  textDark: '#3E3E3E',
};
